import ApiService from './ApiService';

class ShareSplittingService {
  async performSplit(payload = {}) {
    try {
      const response = await ApiService.call('/secured/create_stock_split', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new ShareSplittingService();
